import * as React from 'react'
import './App.scss'
import Footer from './components/footer/Footer'
import Header from './components/header/Header'
import Main from './Main'


const AppIndividual = () => {
	return (
		<div className="App">
			<Header />
			<div className="App__Content">
				<Main />
			</div>
			<Footer />
		</div>
	)
}

export default AppIndividual
